import React, { createContext, useContext, useState } from "react";
import AppointmentForm from "../components/form/AppointmentForm";

const AppointmentContext = createContext();

export const useAppointment = () => useContext(AppointmentContext);

export const AppointmentProvider = ({ children }) => {
  const [show, setShow] = useState(false);
  const [doctorName, setDoctorName] = useState(null);

  const trackEvent = (eventName, params = {}) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
  };

  const openAppointment = (name = null) => {
    trackEvent("appointment_form_opened", { doctor_name: name });
    setDoctorName(name);
    setShow(true);
  };

  const closeAppointment = () => {
    setShow(false);
    setDoctorName(null);
  };

  return (
    <AppointmentContext.Provider value={{ openAppointment }}>
      {children}
      <AppointmentForm
        show={show}
        handleClose={closeAppointment}
        doctorName={doctorName}
      />
    </AppointmentContext.Provider>
  );
};